exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.async-component-button {\n  display: block;\n  color: #fff;\n  text-decoration: underline;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/style/util/async-component.scss
// module id = 935
// module chunks = 49